<template>
    <div class="splash">
        <div class="splash__spinner" role="status" aria-label="Loading"></div>
    </div>
</template>

<script>
export default {
    name: "Loading",
}
</script>

<style lang="scss" scoped>
.splash {
    height: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--surface-page);
}

/* Same brand ring as the global loader — recolours per tenant via --color-primary. */
.splash__spinner {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    background:
        radial-gradient(farthest-side, var(--color-primary) 94%, transparent)
            top center / 6px 6px no-repeat,
        conic-gradient(transparent 25%, var(--color-primary));
    -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 6px));
            mask: radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 6px));
    animation: splash-spin 0.85s linear infinite;
}

@keyframes splash-spin {
    to { transform: rotate(360deg); }
}
</style>
